import { makeStorage } from './makeStorage';

export type OfflineStorage = ReturnType<typeof makeStorage>;

// @ts-expect-error TS(4023): Exported variable 'offlineStorage' has or is using... Remove this comment to see the full error message
export const offlineStorage = makeStorage();
